export enum NotificationsActions {
  Reset = "reset",
  FetchNotifications = "fetchNotifications",
  ReadNotification = "readNotification",
}
